import React from 'react';
import { Router } from 'react-router-dom';

import { FeatureAppDefinition } from '@feature-hub/core';
import { ReactFeatureApp } from '@feature-hub/react';
import { ThemeProvider } from '@vw-marketing/us-components';

import { App } from './app';
import { FeatureAppConfig, FeatureAppDependencies } from './typing/main';
import { FeatureAppEnvironmentContext } from './hooks/use-feature-app-environment';
import { featureAppMemoryStoreDefinition } from './store/feature-app-memory-store';

export const featureAppDefinition: FeatureAppDefinition<
  ReactFeatureApp,
  FeatureAppDependencies,
  FeatureAppConfig
> = {
  dependencies: {
    featureServices: {
      's2:history': '^2.0.0',
      's2:serialized-state-manager': '^1.0.0',
      'feature-app-memory-store': '^1.0.0',
      'featureapp-service': '^1.3.0',
      'layer-manager': '^2.3.0',
      'locale-service': '^1.0.0',
      'service-config-provider': '^1.0.0',
      'disclaimer-manager': '^1.1.0',
    },
  },

  optionalDependencies: {
    featureServices: {
      's2:async-ssr-manager': '^1.0.0',
      's2:logger': '^1.0.0',
      's2:server-request': '^1.0.0',
      'compare': '^2.0.0',
      'data-version-service': '^1.0.0',
      'fa-content-service': '^1.0.0',
      'page-info-service': '^1.0.0',
      'tracking': '^1.0.0',
    },
  },

  ownFeatureServiceDefinitions: [featureAppMemoryStoreDefinition],

  create: (env) => {
    const { featureServices } = env;

    const { 's2:history': historyService } = featureServices;

    const history = historyService.history;

    return {
      undefined,
      render: () => (
        <FeatureAppEnvironmentContext.Provider value={env}>
          <Router history={history}>
            <ThemeProvider theme="main">
              <App />
            </ThemeProvider>
          </Router>
        </FeatureAppEnvironmentContext.Provider>
      ),
    };
  },
};

export default featureAppDefinition;
